import theme from "@/theme";
import { SxProps, Theme } from "@mui/material";

export const styles: Record<string, SxProps<Theme>> = {
  containerBox: {
    width: "800px",
    height: "52px",
  },
  toolbarStack: {
    width: "fit-content", 
    height: "52px",
    bgcolor: "white",
    borderRadius: "29px",
    padding: "12px",
    gap: "24px",
    boxShadow: "0px 4px 6px 0px #545B6114",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  leftControlsWrapper: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  undoRedoWrapper: {
    marginRight: "21px",
    display: "flex",
    justifyContent: "center",
    width: "57px",
    height: "24px",
    gap: "9px",
    "& .MuiIconButton-root": {
      padding: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  },
  paidContentWrapper: {
    width: 127,
    height: 24,
    borderRadius: "22px",
    gap: "6px",
    padding: "2px 8px",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    whiteSpace: "nowrap",
    marginRight: "21px",
    "& .MuiFormControlLabel-label": {
      fontFamily: "Inter",
      fontWeight: 500,
      fontStyle: "Medium",
      fontSize: "14px",
      lineHeight: "20px",
      letterSpacing: 0,
      textAlign: "center",
      verticalAlign: "middle",
      color: "#2A2D31",
    },
    "& .MuiCheckbox-root": {
      padding: 0,
      width: 18,
      height: 18,
    },
  },

  divider: { mx: "21px" },
  selectFormControl: { width: 132, height: 32, marginRight: "21px" },
  select: {
    width: "100%",
    height: "100%",
    borderRadius: "8px",
    border: "1px solid #C6CACE",
    boxSizing: "border-box",
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: 14,
    lineHeight: "20px",
    color: "#2A2D31",
    textAlign: "left",
    display: "flex",
    alignItems: "center",
    "& .MuiSelect-select": {
      paddingRight: "28px !important",
      paddingLeft: "12px",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
    },
    "& .MuiOutlinedInput-notchedOutline": { border: "none" },
    "&:hover": { borderColor: "#C6CACE" },
    "&.Mui-focused": { borderColor: theme.palette.custom.mainBlue, boxShadow: "none" },
    "& .MuiSelect-icon": { right: 8, color: "#52575D" },
  },
  selectMenuProps: {
    borderRadius: "12px",
    marginTop: "6px",
    boxShadow: "0px 8px 24px 0px #545B611F",
    "& .MuiList-root": { padding: "6px" },
  },
  menuItem: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: 14,
    lineHeight: "20px",
    textAlign: "left",
    color: "#2A2D31",
    padding: "8px 12px",
    borderRadius: "8px",
    "&:hover": { backgroundColor: "#F2F5F9" },
    "&.Mui-selected": { backgroundColor: "#EAF1FE" },
    "&.Mui-selected:hover": { backgroundColor: "#EAF1FE" },
  },
  inlineStyleButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "1.5rem",
    "& .MuiIconButton-root": {
      padding: 0,
    },
  },
  alignButtonsWrapper: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "1.25rem",
    maxWidth: "156px",
  },
  iconButton: { p: 0 },
  paidContentCheckbox: { whiteSpace: "nowrap" },
  insertImageButton: {
    textTransform: "none",
    whiteSpace: "nowrap",
    padding: 0,
    fontFamily: "Inter",
    fontWeight: 500,
    fontStyle: "Medium",
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: 0,
    textAlign: "center",
    verticalAlign: "middle",
    color: theme.palette.custom.mainBlue,
  },
  errorText: { textAlign: "center", fontWeight: 700 },
};
